import { combineReducers } from 'redux';

export function toID(url) {
    if (url == null) return url;
    // Slices the ID out of a URL like
    // "/api/v3/content/3/"
    const id = url
        .split('/')
        .slice(-2)
        .shift();
    return parseInt(id, 10);
}

export function switcher(defaultState, obj) {
    return (state = defaultState, action) => {
        let { type } = action;
        if (obj[type]) {
            if (typeof obj[type] === 'string') {
                type = obj[type];
            }

            state = obj[type](state, action);

            if (state === undefined) {
                throw new Error('Invalid state');
            }
        }
        return state;
    };
}

export { combineReducers };



// WEBPACK FOOTER //
// ./src/reducers/utils.js